import { DEFAULT_LOCALE, RTL_LOCALES, resources, type Locale } from './resources'

type Vars = Record<string, unknown>

const pathLookup = (obj: Record<string, unknown>, path: string): unknown =>
  path.split('.').reduce<unknown>((acc, part) => (acc && typeof acc === 'object' ? (acc as Record<string, unknown>)[part] : undefined), obj)

export const resolveLocale = (raw?: string | null): Locale => {
  if (!raw) return DEFAULT_LOCALE
  const normalized = raw.toLowerCase().split('-')[0]
  return (normalized in resources ? normalized : DEFAULT_LOCALE) as Locale
}

export const isRtl = (locale: Locale): boolean => RTL_LOCALES.includes(locale)

export const translate = (locale: Locale, key: string, vars?: Vars): string => {
  const fromLocale = pathLookup(resources[locale] as Record<string, unknown>, key)
  const fallback = pathLookup(resources[DEFAULT_LOCALE] as Record<string, unknown>, key)
  const raw = typeof fromLocale === 'string' ? fromLocale : typeof fallback === 'string' ? fallback : key

  if (!vars) return raw
  return Object.keys(vars).reduce((acc, k) => acc.replaceAll(`{${k}}`, String(vars[k])), raw)
}
